<template>
  <div class="container py-5">

    <p>
    IMCAS World Congress
    <br> 
    地點：Palais des Congrès de Paris
    <br> 
    時間：2024/2/1-3
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_43.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
